// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	CloseButton: 'close-button',
	LoginButton: 'login-button',
	AccountNameDropdown: 'account-name-dropdown',
	EditIcon: 'edit-icon',
	AccountName: 'account-name',
	Username: 'username',
	Password: 'password',
	Link1: 'link-1',
	Link2: 'link-2',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
